/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GitRepositoryLikeParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['name', codecString],
    ['url', codecString],
    ['isTemplate', codecBoolean, 'is_template'],
    ['isPrivate', codecBoolean, 'is_private'],
]);
export class GitRepositoryLike extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GitRepositoryLikeParser.decode(input).map(res => new GitRepositoryLike(res));
    }
    static unsafeDecode(input) {
        return GitRepositoryLike.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GitRepositoryLikeParser.encode(data);
    }
    static schema() {
        return GitRepositoryLikeParser.schema();
    }
}
